import React, { useEffect, useRef, useState } from 'react';
import './manage-contributions.styles.scss';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPiggyBank } from '@fortawesome/free-solid-svg-icons';
import ManageContributionCard from './manage-contribution-card.component';
import { getCollectionFromDb } from '@/utils/getDataFromDb';

const ManageContributions = ({
    gameData,
    gameActivity,
    playerList,
    gameStats,
}) => {

    const [ contributionsToDisplay, setContributionsToDisplay ] = useState([]);
    const contributionsRef = useRef({});
    let contributionsListener;
    const navigate = useNavigate();

    useEffect(() => {
        return () => {
            if (contributionsListener) contributionsListener();
        }
    }, [])

    useEffect(() => {
        if (!gameData) return;
        getContributionsToDisplay(); 
    }, [gameData]);    

    function getContributionsToDisplay() {
        getCollectionFromDb({
            "collection": `games/${gameData.gameId}/gameElements`,
            "query1": {
                "key": "opt_itemType",
                "condition": "==",
                "value": "contribution"
            },
            "callback": callback,
            "handleListener": handleListener
        })
        function callback(data) {
            console.log(data);
            contributionsRef.current = {
                ...contributionsRef.current,
                ...{[data.id]: data}
            }
            setContributionsToDisplay(Object.values(contributionsRef.current));
        }
        function handleListener(data) {
            contributionsListener = data;
        }
    }

    return (
        <div className='manage-contributions'>
            <div className='g-card contributions-card'>
                <BackButton cancel={() => navigate(`/manage/${gameData.path}`)} />
                    <div className="g-space-1"></div>
                <div className='card-title'>
                    <div className='title-with-icon'>
                        <FontAwesomeIcon icon={faPiggyBank} />Manage Contributions
                    </div>
                </div>
                <hr />
                <div className='contribution-list'>
                {
                    (contributionsToDisplay.length > 0)
                    ?
                    contributionsToDisplay.map(c => (
                        <div 
                            key={c.id} 
                            className='contribution-card' >
                            <ManageContributionCard
                                gameData={gameData}
                                item={c}
                                gameStats={gameStats}
                                // gameActivity={gameActivity}
                                playerList={playerList} />
                        </div>
                    ))
                    :
                    <h3>No contributions yet...</h3>
                }
                </div>
            </div>
        </div>
    )
}

export default ManageContributions